import React, { useCallback, useEffect, useState } from "react";
import styles from "./index.module.scss";
import startBg from "../../assets/images/startBg.jpg";
import { Header } from "../HomeScene";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import useCart from "../../customHooks/useCart";
import btnLight from "../../assets/images/btnLight.png";
import ViewCart from "../../components/ViewCart";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";

function WineDetail({ db }) {
  const innerHeight = window.innerHeight;
  const { state } = useLocation();
  const { details = {} } = state;
  const { intro = "", name = "", RETAIL = [],AWARDS=[] } = details;

  const POINTS = [
    "TASTE DESCRIPTION",
    "REGION",
    "PAIRING",
    "AWARDS",
    "ALCOHOL CONTENT",
    "RETAIL",
  ];
  const [activeTab, setActiveTab] = useState(POINTS[0]);
  const [winesList, setWinesList] = useState([]);
  const [tastingList, setTastingList] = useState([]);
  

  const { addToCart, cart, removeFromCart, isCartEmpty, placeOrder, clearCart } =
    useCart();

  const fetchWines = useCallback(async () => {
    let wines = [];
    const querySnapshot = await getDocs(collection(db, "wines"));
    querySnapshot.forEach((doc) => {
      wines.push(doc.data());
    });

    let newObj = {}
    wines.map(wine => {
      newObj[wine.name]  = wine
    })
    
    
    const newList = tastingList.filter(wine => 
      !Object.keys(newObj).includes(wine.name)
    )    

    setWinesList([...wines, ...newList]);

  }, [db, tastingList]);


  

  const fetchTastingNotes = useCallback(async () => {
    const docRef = doc(db, "tastingNotes", "Xm6PBat6Jmq9Ap2ckA2d");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setTastingList(docSnap.data().collection);
    } else {
      // console.log("No such document!");
    }
  }, [db]);

  useEffect(() => {
    fetchTastingNotes();
  }, [fetchTastingNotes]);

  useEffect(() => {
    fetchWines();
  }, [fetchWines]);

  const [scrollPosition, setScrollPosition] = useState(0);
const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
};

useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);

  return (
    <div
      className={styles.detailContainer}
      style={{
        backgroundImage: `url(${startBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        transition: "all ease .8s",
        overflow: "hidden",
        color: "#fff",
        position: "relative",
        minHeight: innerHeight,
      }}
    >
      <Header />
      <div className={styles.detailWrapper}>
        <div className={styles.detailCard}>
          <Link to="/notes">
            <div className={styles.backBtn}>{`< Back`}</div>
          </Link>
          <div className={styles.details}>
            {/* <div className={styles.left}>
              <div>
                <h3>{intro}</h3>
                <h2>{name}</h2>
              </div>
              <div className={styles.pointsContainer}>
                {POINTS.map((point, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => setActiveTab(point)}
                      className={`${styles.point} ${
                        activeTab === point && styles.active
                      }`}
                    >
                      {point}
                    </div>
                  );
                })}
              </div>
              <div className={styles.tabData}>
                {details[activeTab]?.map((item, index) => {
                  return (
                    <div key={index} className={styles.tabPoint}>
                      {item}
                    </div>
                  );
                })}
              </div>
            </div> */}
            <div className={styles.imagesLeft}>
              <div className={styles.activeImg}>
                <img
                  src={details?.imgFull}
                  alt={name}
                  className="animate__animated animate__fadeIn"
                />
              </div>
            </div>
            <div className={styles.detailsRight}>
              <div className={styles.wineName}>{name}</div>
              {POINTS.map((point, index) => point==="AWARDS"?       
                <React.Fragment key={"awards"}>
                  <h4>{point}</h4>
                  {AWARDS?.map((it,ind)=>  <div key={ind} className={styles.data}>{it}</div>)}
                </React.Fragment>
              :(
                <React.Fragment key={index}>
                  {details[point]?.map((item, i) => {
                    if (point !== "AWARDS") {                    
                    return (
                      <React.Fragment key={i}>
                        <h4>{point}</h4>
                        <div className={styles.data}>{point === "RETAIL" && !(item == "LANDING SOON" || item == "SOLD OUT") ? `THB ${item} incl. VAT ` : item}</div>
                      </React.Fragment>
                    );
                    }
                  })}
                </React.Fragment>
              ))}
            </div>
            {/* <div className={styles.imgWrapper}>
              <img src={details?.imgFull} />
            </div> */}
          </div>
        </div>
      </div>
      <div className={styles.cartBtn}>
        {cart[name] ? (
          <div className={styles.addedToCart}>
            <div
              className={`${styles.updateBtn} ${styles.btnMinus}`}
              onClick={() => removeFromCart(name)}
            >
              -
            </div>
            <div>{cart[name].count}</div>
            <div
              className={`${styles.updateBtn} ${styles.btnPlus}`}
              onClick={() =>
                addToCart(name, RETAIL.length > 0 ? RETAIL[0] : "")
              }
            >
              +
            </div>
            <ViewCart
              cart={cart}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              isCartEmpty={isCartEmpty}
              winesList={winesList}
              placeOrder={placeOrder}
              clearCart={clearCart}
            />
          </div>
        ) : (
          <div
            className={styles.addBtn}
            onClick={() =>{
             addToCart(name, RETAIL.length > 0 ? RETAIL[0] : "")}}
            style={{
              backgroundImage: `url(${btnLight})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              width: "191px",
              height: "56px",
            }}
          >
            Add to cart
          </div>
        )}
      </div>
    </div>
  );
}
export default WineDetail;
